module.exports = __webpack_public_path__ + "assets/cb53ba9f63586d9d30229a85a284ada9.png";